// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/alert.js
import BaseComponent from "./base_component"

export default class Alert extends BaseComponent {
  static componentName = "alert"

  close() {
    if (this.emit("close", {}, { cancelable: true }).defaultPrevented) return
    this.element.classList.remove("show")
    this.afterTransition(
      this.element,
      () => {
        this.emit("closed")
        this.element.remove()
        this.dispose()
      },
      this.element.classList.contains("fade"),
    )
  }
}
